import type { CommentPanelSort } from "./commentPanelSort.types";

export type CommentPanelSortOption = {
  value: CommentPanelSort;
  label: string;
  description: string;
};

/** Needs attention while read times are unknown: it cannot rank unread threads yet. */
export const PRIORITY_SORT_DESCRIPTION_WITHOUT_READ_STATUS =
  "Unresolved first until read status loads, otherwise newest first";

export const COMMENT_PANEL_SORT_OPTIONS: CommentPanelSortOption[] = [
  {
    value: "priority",
    label: "Needs attention",
    description: "Unread and unresolved first, otherwise newest first",
  },
  {
    value: "newest_replies",
    label: "Recently replied",
    description: "Threads with the latest replies",
  },
  {
    value: "newest",
    label: "Newest first",
    description: "Newest comments first",
  },
  {
    value: "oldest",
    label: "Oldest first",
    description: "Oldest comments first",
  },
];
